import { render, staticRenderFns } from "./PackagePolicySuccess.vue?vue&type=template&id=9879d528&scoped=true"
import script from "./PackagePolicySuccess.vue?vue&type=script&lang=js"
export * from "./PackagePolicySuccess.vue?vue&type=script&lang=js"
import style0 from "./PackagePolicySuccess.vue?vue&type=style&index=0&id=9879d528&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9879d528",
  null
  
)

export default component.exports